<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <material-card
          color="green"
          :loading="loading"
        >
          <v-form
            ref="form"
          >
            <v-container class="py-0">

                        <PersonToolbar v-if="this.$route.params.id" :personId=this.$route.params.id></PersonToolbar>

              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="model.name"
                    label="Nome Completo"
                    :rules="rules.name"
                    @keyup.enter="handleSubmit"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="model.email"
                    label="Email"
                    class="purple-input"
                    :rules="rules.email"
                    @keyup.enter="handleSubmit"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="model.cpf"
                    label="CPF"
                    :rules="rules.cpf"
                    v-mask="'###.###.###-##'"
                    @keyup.enter="handleSubmit"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-select
                    v-model="model.type_id"
                    label="Categoria"
                    :items="types"
                    :loading="loading"
                    item-text="name"
                    item-value="id"
                    single-line
                    :rules="rules.type"
                    @keyup.enter="handleSubmit"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="model.card_number"
                    label="Número do Cartão"
                    class="purple-input"
                    :rules="rules.card_number"
                    @keyup.enter="handleSubmit"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="model.enrollment"
                    label="Matrícula"
                    class="purple-input"
                    :rules="rules.enrollment"
                    @keyup.enter="handleSubmit"
                  />
                </v-col>
              </v-row>
              <v-row>

                <v-col
                  cols="12"
                  class="text-right"
                >
                  <v-btn
                    :loading="loading"
                    color="success"
                    @click="handleSubmit()"
                  >
                    {{ action == 'POST' ? 'CRIAR' : 'EDITAR' }} Pessoa
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    import {
        mapState,
    } from 'vuex'
    import {mask_cpf, validate, cleaner} from '../../utils/cpf'

    export default {
        data() {
            return {
                rules: {
                    name: [(v) => !!v || 'Campo Obrigatório', (v) => (!!v && v.length <= 255) || 'Nome não pode possuir mais que 255 caracteres',],
                    enrollment: [(v) => (!!v && v.length >= 8) || 'Matrícula não pode possuir menos que 8 caracteres', (v) => (!!v && v.length <= 12) || 'Matrícula não pode possuir mais que 12 caracteres',],
                    email: [(v) => !!v || 'Campo Obrigatório', (v) => /.+@.+\..+/.test(v) || 'E-mail deve ser válido'],
                    cpf: [(v) => !!v || 'Campo Obrigatório', (v) => validate(v) || 'CPF Inválido'],
                    card_number: [(v) => (!!v && v.length >= 8) || 'Cartão não pode possuir menos que 8 caracteres', (v) => (!!v && v.length <= 10) || 'Cartão não pode possuir mais que 10 caracteres',],
                    type: [(v) => !!v || 'Campo Obrigatório'],

                },
                action: 'POST',
                passwordEnabled: true,
                edit: {}
            }
        },
        computed: {
            ...mapState('person', ['types']),
            ...mapState('app', ['loading']),
            model() {
                this.$emit('change', this.edit.cpf)
                return {
                    name: this.edit.name,
                    email: this.edit.email,
                    cpf: this.edit.cpf ? mask_cpf(this.edit.cpf) : null,
                    card_number: this.edit.card_number,
                    type_id: this.edit.type ? this.edit.type.id : this.types[0].id,
                    enrollment: this.edit.enrollment,
                }
            },
        },
        mounted() {
            if (this.$route.params.id) {
                this.get()
            } else {
                this.$refs.form.resetValidation()
            }
        },
        methods: {
            handleSubmit() {
                if (this.$refs.form.validate())
                    return this.post()

            },
            togglePassword(toggle) {
                this.passwordEnabled = toggle
                return true
            },
            get() {
                this.$store.dispatch('person/GET', {
                    id: this.$route.params.id,
                }).then((response) => {
                    this.edit = response
                }).catch(() => {

                })
                this.action = 'PATCH'
            },
            post() {
                const vm = this
                this.model.cpf = cleaner(this.model.cpf)
                this.$store.dispatch(`person/${this.action}`, {
                    id: this.$route.params.id,
                    model: this.model,
                }).then((response) => {
                    this.$store.commit('app/SHOW_NOTIFICATION', {
                        body: `${this.model.name} ${this.action === 'POST' ? 'criado' : 'editado'} com sucesso.`,
                        color: 'green',
                        timeout: 8000,
                        link: {body: 'Cadastrar Digitais', to: `/persons/${response.id}/fingerprints`}
                    }, {root: true})
                    vm.$router.push('/persons')
                }).catch((e) => {
                    console.log(e)
                })
            },
        },
    }
</script>
